import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';
import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prop-types
const AnnouncementTableHeader = ({
  handleShow,
  license,
  options,
  setSearchText,
  setLicense
}) => {
  const { getSelectedRowModel } = useAdvanceTableContext();

  const deleteMultipleRecord = async array => {
    handleShow({}, 'Announcement', 'Selected', array);
  };

  return (
    <>
      <Row className="">
        {getSelectedRowModel().rows.length > 0 ? (
          <div className="d-flex">
            <IconButton
              variant="success"
              size="sm"
              icon="bell"
              transform="shrink-3"
              className="mx-2"
              onClick={() => {
                deleteMultipleRecord(
                  getSelectedRowModel().rows?.map(i => i?.original?.original)
                );
              }}
            >
              <span className="d-none d-sm-inline-block ms-1">
                Send Selected
              </span>
            </IconButton>
          </div>
        ) : (
          <>
            <Col sm={2} className="mt-2">
              <Form.Control
                placeholder="Search by name..."
                onChange={e => setSearchText(e.target.value)}
                size="sm"
              />
            </Col>
            <Col sm={2} className="mt-2">
              <Form.Select
                onChange={e => setLicense(e.target.value)}
                size="sm"
                value={license}
              >
                <option value="">All License</option>
                {options.map(option => (
                  <option key={option}>{option}</option>
                ))}
              </Form.Select>
            </Col>
            <Col xs="auto" className="d-flex mt-2 order-md-0">
              <IconButton
                variant="success"
                size="sm"
                icon="bell"
                transform="shrink-3"
                onClick={() => {
                  handleShow({}, 'Announcement', 'All', []);
                }}
              >
                <span className="ms-1">Announcement</span>
              </IconButton>
              <IconButton
                variant="danger"
                size="sm"
                icon="bolt"
                className="mx-2"
                transform="shrink-3"
                onClick={() => {
                  handleShow({}, 'Weather', 'All', []);
                }}
              >
                <span className="ms-1">Weather</span>
              </IconButton>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

AnnouncementTableHeader.propTypes = {
  handleShow: PropTypes.any,
  license: PropTypes.any,
  options: PropTypes.any,
  setSearchText: PropTypes.any,
  setLicense: PropTypes.any
};

export default AnnouncementTableHeader;
